// extracted by mini-css-extract-plugin
export var modalFooter = "_sx-0";